import type { ReactNode } from 'react';

type Props = {
  titulo: string;
  descricao?: string;
  acoes?: ReactNode;
};

export function PageHeader({ titulo, descricao, acoes }: Props) {
  return (
    <div className="page-header">
      <div>
        <h2 className="page-header__title">{titulo}</h2>
        {descricao && <p className="page-header__subtitle">{descricao}</p>}
      </div>
      {acoes && <div className="page-header__actions">{acoes}</div>}
    </div>
  );
}
